import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Modal, Button, Form } from 'react-bootstrap';
import '../utils/Usuarios.css';

//const API_URL_USUARIOS = process.env.REACT_APP_API_URL + '/usuarios'; // <-- Cambio aquí
const API_URL_USUARIOS = process.env.REACT_APP_API_URL 
? `${process.env.REACT_APP_API_URL}/usuarios` 
: 'http://localhost:4000/usuarios';

const Usuarios = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [searchEmail, setSearchEmail] = useState('');
  const [selectedUsuario, setSelectedUsuario] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [newUsuario, setNewUsuario] = useState({
    nombre: '',
    cedula: '',
    direccion: '',
    telefono: '',
    rol: 'Consumidor',
    usuario: '',
    contrasenia: '',
  });
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    fetchUsuarios();
  }, []);

    // Agregar el token a las cabeceras de la solicitud
  const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  const fetchUsuarios = async () => {
    try {
      const headers = getAuthHeaders();
      const response = await axios.get(API_URL_USUARIOS, { headers });
      setUsuarios(response.data);
    } catch (error) {
      console.error('Error fetching usuarios data:', error);
    }
  };
  
  const handleAddUsuario = async (e) => {
    e.preventDefault();
    const { nombre, cedula, direccion, telefono, rol, usuario, contrasenia } = newUsuario;

    if (!nombre || !cedula || !direccion || !telefono || !usuario || !contrasenia) {
      setErrorMessage('Todos los campos son obligatorios.');
      return;
    }

    try {
      const headers = getAuthHeaders();
      await axios.post(API_URL_USUARIOS, newUsuario, { headers });
      fetchUsuarios();
      handleCloseModal();
    } catch (error) {
      console.error('Error adding usuario:', error);
      setErrorMessage('Error al agregar el usuario.');
    }
  };

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => {
    setShowModal(false);
    setNewUsuario({
      nombre: '',
      cedula: '',
      direccion: '',
      telefono: '',
      rol: 'Consumidor',
      usuario: '',
      contrasenia: '',
    });
    setErrorMessage('');
  };

  return (
    <div className="usuarios-panel">
      <div className="header-buttons">
        <Button variant="primary" onClick={handleOpenModal}>+ Nuevo Usuario</Button>
      </div>

      <h2>Gestión de Usuarios</h2>

      <table className="usuarios-table">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Cédula</th>
            <th>Dirección</th>
            <th>Teléfono</th>
            <th>Fecha Registro</th>
            <th>Rol</th>
            <th>Usuario</th>
          </tr>
        </thead>
        <tbody>
          {usuarios.map((usuario) => (
            <tr key={usuario.id_usuario}>
              <td>{usuario.nombre}</td>
              <td>{usuario.cedula}</td>
              <td>{usuario.direccion}</td>
              <td>{usuario.telefono}</td>
              <td>{usuario.fecha_registro}</td>
              <td>{usuario.rol}</td>
              <td>{usuario.usuario}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Agregar Nuevo Usuario</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
          <Form onSubmit={handleAddUsuario}>
            <Form.Group>
              <Form.Label>Nombre</Form.Label>
              <Form.Control
                type="text"
                value={newUsuario.nombre}
                onChange={(e) => setNewUsuario({ ...newUsuario, nombre: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Cédula</Form.Label>
              <Form.Control
                type="text"
                value={newUsuario.cedula}
                onChange={(e) => setNewUsuario({ ...newUsuario, cedula: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Dirección</Form.Label>
              <Form.Control
                type="text"
                value={newUsuario.direccion}
                onChange={(e) => setNewUsuario({ ...newUsuario, direccion: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Teléfono</Form.Label>
              <Form.Control
                type="text"
                value={newUsuario.telefono}
                onChange={(e) => setNewUsuario({ ...newUsuario, telefono: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Rol</Form.Label>
              <Form.Control
                as="select"
                value={newUsuario.rol}
                onChange={(e) => setNewUsuario({ ...newUsuario, rol: e.target.value })}
              >
                <option value="Administrador">Administrador</option>
                <option value="Presidente">Presidente</option>
                <option value="Tesorero">Tesorero</option>
                <option value="Consumidor">Consumidor</option>
                <option value="Externo">Externo</option>
              </Form.Control>
            </Form.Group>
            <Form.Group>
              <Form.Label>Usuario</Form.Label>
              <Form.Control
                type="text"
                value={newUsuario.usuario}
                onChange={(e) => setNewUsuario({ ...newUsuario, usuario: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Contraseña</Form.Label>
              <Form.Control
                type="password"
                value={newUsuario.contrasenia}
                onChange={(e) => setNewUsuario({ ...newUsuario, contrasenia: e.target.value })}
                required
              />
            </Form.Group>
            <Button variant="primary" type="submit">Agregar</Button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Usuarios;
